import { Component, OnInit, Input } from '@angular/core';
import { MasterDataService } from '../masterdata/masterdata.service';
import { ErrorHandler } from '../utils/error-handler';
import { MessagesService } from '../messages/messages.service';

@Component({
  selector: 'app-standard-primer',
  templateUrl: './standard-primer.component.html',
  styleUrls: ['./standard-primer.component.css']
})
/* 
 * @description: This component represents Standard Primer module in GUI
 */
export class StandardPrimerComponent implements OnInit {

  @Input() masterLists: any[];
  @Input() tableCols: any[];
  @Input() title: string;
  
  selectedMasterList: any;
  errorHandler: ErrorHandler = new ErrorHandler;

  isPrimerName: string = "primerName";
  isPrimerID: string = "primerID";
  isSequence: string = "sequence";
  isGC: string = "gc";
  isTM: string = "tm";
  isQcPrimer: string = "qcPrimer";
  isActive: string = "active";

  displayMasterListDialog: boolean;
  isNewMasterList: boolean;
  masterList: any;
  popupTitle:string;

  constructor(private _masterDataService: MasterDataService,private _messageService: MessagesService) { }

  ngOnInit() {
    this.popupTitle = this.title.slice(0, -1);
  }

  // Popup dialogue box for adding new Standard prmier
  showDialogToAddMasterList(){
    this.isNewMasterList= true;
    this.masterList = {};
    this.displayMasterListDialog= true;
    this.masterList.active = true;
  }

  // on click of row select
  onRowSelect(event) {
    this.isNewMasterList = false;
    this.masterList = this.cloneMasterList(event.data);
    this.displayMasterListDialog = true;
    
  }

  cloneMasterList(list: any): any {
    let masterList = {};
    for (let prop in list) {
      masterList[prop] = list[prop];
    }
    return masterList;
  }

  // to save or update .
  saveMasterList() {
  console.log(this.masterList);

    let masterLists = [...this.masterLists];

    if (this.isNewMasterList) {
      this.saveMasterData(masterLists);
    }
    else {
      this.updateMasterData(masterLists);
    }
  }

  // to add a standard primer to the Database
  saveMasterData(masterLists) {
    this._masterDataService.addStandardPrimer(this.masterList).subscribe(
      results => {
        if (!results || !results.data) {
          return;
        }
        masterLists = [...this.masterLists];
        console.log("Standard Primers:", results.data);
        masterLists.push(results.data);
        this.masterLists = masterLists;
        this.masterList = null;
        this.displayMasterListDialog = false;
      },
      error => {
        this._messageService.addAllErrorMessages(this.errorHandler.handleBBApiErrors(error.error.bbApiError));
        this.displayMasterListDialog = true;
      }
    );
  }
  //Update Existing Standard Primer
  updateMasterData(masterLists) {
    this._masterDataService.updateStandardPrimer(this.masterList).subscribe(
      results => {
        if (!results || !results.data) {
          return;
        }
        console.log("Standard Primers:", results.data);
        masterLists[this.masterLists.indexOf(this.selectedMasterList)] = results.data;
        this.masterLists = masterLists;
        this.masterList = null;
        this.displayMasterListDialog = false;
      },
      error => {
        this._messageService.addAllErrorMessages(this.errorHandler.handleBBApiErrors(error.error.bbApiError));
        this.displayMasterListDialog = true;
      }
    );
  }

  removeSpaces(value:string){
    return value.trim();
  }

  // Save is enabled only if primer name and primer Id fields are not empty
  isSaveDisabled(){
    if (this.masterList == undefined || this.masterList == null)
      return true;
    else if (!this.masterList.primerName || !this.masterList.primerID)
      return true;
    else
      return false;
  }


}
